'use client';

import { usePathname } from 'next/navigation';
import { Header } from './Header';
import { Footer } from './Footer';

export function LayoutWrapper({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    const isInternshipPage = pathname === '/internship-assignments';

    if (isInternshipPage) {
        return <main className="flex-grow">{children}</main>;
    }

    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main className="flex-grow">{children}</main>
            <div className='h-40 bg-secondary/50'></div>
            <Footer />
        </div>
    );
}
